import { useWorkspaces } from "@/hooks/useWorkspaces";
import { VocCountData } from "@/models/vocCount";
import { VocService } from "@/services/voc/voc.service";

export function useVocCountData() {
  const { categoryMaxLevel, sessionCurrentWorkspaceId } = useWorkspaces();
  const displayLayerLevel = categoryMaxLevel - 1;
  const { data, error, isLoading } = VocService.getVocCountData(
    sessionCurrentWorkspaceId,
    displayLayerLevel,
  );

  const filterByPaths = (paths: string[]) => {
    if (!data) return;

    const filtered = data.counts.filter((vc) => paths.includes(vc.categoryPath));
    return new VocCountData(filtered, data.latestYearMonth);
  };

  return {
    vocCountData: data,
    error,
    isLoading,
    filterByPaths,
  };
}
